import React, {useState} from 'react';

function SimpleCheckbox({isChecked, onChange = () => {}, label, loading, isHoveredClass=''}) {


    const [isHovered, setIsHovered] = useState(false)
    const getIcon = () => {
        if (loading) {
            return <i data-testid="checkmark" className='fas fa-spinner fa-spin has-text-grey' />
        }
        if (isChecked) {
            return <i data-testid="checkmark" className='fas fa-check-square has-text-success' />
        }

        if (isHovered) {
            return <i data-testid="checkmark" className='far fa-check-square' />
        }
        return <i data-testid="checkmark" className='far fa-square has-text-grey' />
    }

    return (
        <div className="is-flex"
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            onClick={() => onChange(!isChecked)}
        >
            <span  className="cursor-is-pointer" data-testid="checkmark-container" >
                {getIcon()}
            </span>
            <span className={`pl-3 cursor-is-pointer ${(isHovered || isChecked) ? 'has-text-black' : 'has-text-grey-dark'}`}>
                {label}
            </span>
        </div>
    )
} 


export default SimpleCheckbox